// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.innovative-subscription-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Arial', sans-serif;
  }
  
  header {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .subscription-plans {
    display: flex;
    justify-content: space-around;
    gap: 20px;
  }
  
  .subscription-plan {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .subscription-plan h3 {
    color: #333;
  }
  
  .subscription-plan p {
    color: #777;
  }
  
  .subscription-plan ul {
    list-style-type: none;
    padding: 0;
  }
  
  .subscription-plan li {
    margin-bottom: 5px;
  }
  
  .subscription-plan button {
    background-color: #4caf50;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .subscription-plan button:hover {
    background-color: #45a049;
  }
  
  .innovative-feature {
    margin-top: 50px;
    text-align: center;
  }
  
  .innovative-feature h2 {
    color: #333;
  }
  
  .innovative-feature p {
    color: #777;
  }
  
  .innovative-feature img {
    max-width: 100%;
    border-radius: 8px;
    margin-top: 20px;
  }

  .text-muted {
    color: #999; /* Change the color to a lighter shade */
    font-size: 20px;  /* Adjust the size of the text-muted span */
  }
  .subscription_home{
    padding: 4% 10% 0 10%;
  }
  @media (max-width: 768px) {
    .subscription_home{
      padding: 4% 10%;
      margin: 0 0 0 15px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/SubscriptionsPage/SubscriptionsHome/SubscriptionsHome.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW,EAAE,wCAAwC;IACrD,eAAe,GAAG,2CAA2C;EAC/D;EACA;IACE,qBAAqB;EACvB;EACA;IACE;MACE,eAAe;MACf,kBAAkB;IACpB;EACF","sourcesContent":[".innovative-subscription-page {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Arial', sans-serif;\n  }\n  \n  header {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  \n  .subscription-plans {\n    display: flex;\n    justify-content: space-around;\n    gap: 20px;\n  }\n  \n  .subscription-plan {\n    background-color: #f5f5f5;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .subscription-plan h3 {\n    color: #333;\n  }\n  \n  .subscription-plan p {\n    color: #777;\n  }\n  \n  .subscription-plan ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .subscription-plan li {\n    margin-bottom: 5px;\n  }\n  \n  .subscription-plan button {\n    background-color: #4caf50;\n    color: #fff;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .subscription-plan button:hover {\n    background-color: #45a049;\n  }\n  \n  .innovative-feature {\n    margin-top: 50px;\n    text-align: center;\n  }\n  \n  .innovative-feature h2 {\n    color: #333;\n  }\n  \n  .innovative-feature p {\n    color: #777;\n  }\n  \n  .innovative-feature img {\n    max-width: 100%;\n    border-radius: 8px;\n    margin-top: 20px;\n  }\n\n  .text-muted {\n    color: #999; /* Change the color to a lighter shade */\n    font-size: 20px;  /* Adjust the size of the text-muted span */\n  }\n  .subscription_home{\n    padding: 4% 10% 0 10%;\n  }\n  @media (max-width: 768px) {\n    .subscription_home{\n      padding: 4% 10%;\n      margin: 0 0 0 15px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
